import styled from 'styled-components';

const StyledUserContainer = styled.div``;
export default StyledUserContainer;
